import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'translocoDate',
  pure: false,
  standalone: false,
})
export class TranslocoDatePipe implements PipeTransform, OnDestroy {
  private lang = this.transloco.getActiveLang();
  private sub: Subscription;

  constructor(
    private transloco: TranslocoService,
    private cdr: ChangeDetectorRef
  ) {
    this.sub = this.transloco.langChanges$.subscribe((lang) => {
      this.lang = lang;
      this.cdr.markForCheck();
    });
  }

  transform(value: any, format: string = 'EEEE'): string | null {
    // like DatePipe: formatDate throws on a value not loaded yet, which would take the whole template down
    if (value == null || value === '' || value !== value) {
      return null;
    }

    return formatDate(value, format, this.lang);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
